import { useCallback, useContext, useMemo } from 'react';
import { OrderSummaryItem } from '@vp/component-library';
import { OrderDetailsContext } from './OrderDetailsContext';

interface UseOrderSummaryItemsReturn {
  itemSelectorCallback: (itemIds: string[]) => OrderSummaryItem[];
}

/**
 * Takes in a list of lineItemIds and returns a list of the associated
 * OrderSummaryItem objects. Intended to be used with OrderSummary from '@vp/component-library'.
 * @param applicableItemIds
 * @returns
 */
export const useOrderSummaryItems = (): UseOrderSummaryItemsReturn => {
  const context = useContext(OrderDetailsContext);

  const itemSelectorCallback = useCallback(
    (applicableItemIds: string[]) => {
      const orderSummaryItems: OrderSummaryItem[] = [];
      context?.order?.lineItems.forEach(lineItem => {
        if (applicableItemIds.includes(lineItem.id)) {
          const { id, productName, livePreviewUrl, quantity } = lineItem;
          const orderSummaryItem: OrderSummaryItem = {
            id,
            productName,
            previewUrl: livePreviewUrl,
            quantity,
          };
          orderSummaryItems.push(orderSummaryItem);
        }
      });
      return orderSummaryItems;
    },
    [context]
  );

  return useMemo(() => ({ itemSelectorCallback }), [itemSelectorCallback]);
};
